module.exports = __webpack_public_path__ + "img/calender.db7bd11e.svg";